<template>
  <div>
    <p v-if="showNest"
      class="sublabel"
      :style="{
        color: '#AFAFAF',
        fontSize: '12px',
        lineHeight: 'normal',
        marginBottom: '19px',
      }"
    >
      {{ $t('step1TstatDisclaimer') }}
    </p>
    <question-select
      v-bind="$attrs"
      v-on="{ ...$listeners, input: handleInput }"
      id="tstatSelector-question"
      :options="options"
      :value="value"
      :name="name"
      :data-vv-name="name"
      v-validate="validation"
    />
    <div v-if="appLoginOption" class="login-option">
      <div class="login-option-text">
        <p style="font-size:20px;line-height:32px">
          {{ $t(resideoSelected ? 'step1HoneywellResideoEnrollmentInstructions' : 'step1HoneywellFirstAlertEnrollmentInstructions') }}
          <span
            :style="{
              color: theme.primaryColor ||'#016699',
              textDecoration: 'underline'
            }"
            @click="showModal()"
          >
            {{ $t('step1HoneywellClickHere') }}.
          </span>
        </p>
      </div>
      <p style="font-size:20px;line-height:32px">{{ $t('step1HoneywellContinue') }}</p>
    </div>
    <small v-if="errorText" class="tstat-warning form-text text-danger">{{ $t(errorText) }}</small>
  </div>

</template>

<script>
import QuestionSelect from './QuestionSelect.vue';
import defaultTheme from '../../styles/defaultTheme';

export default {
  name: 'question-tstat-select',
  props: ['question', 'validation', 'value', 'name'],
  inject: {
    program: 'program',
    theme: { default: defaultTheme },
  },
  data() {
    return {
      options: [],
      showNest: false,
      errorText: null,
    };
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    appLoginOption() {
      return ['resideoHoneywell', 'firstAlertHoneywell'].includes(this.selected);
    },
    resideoSelected() {
      return this.selected === 'resideoHoneywell';
    },
  },
  watch: {
    value(val) {
      if (val != null) {
        if (this.options.find(({ value }) => value == null)) {
          this.options.shift();
        }
      }
      if (val === 'ecobee') {
        this.$root.$emit('modal.show', 'ecobee');
        this.errorText = null;
      } else if (val === 'nest') {
        this.$root.$emit('modal.show', 'nest');
        this.errorText = null;
      } else if (val === 'other') {
        this.errorText = 'step1TstatError';
      } else {
        this.errorText = null;
      }
    },
  },
  mounted() {
    this.options.push({ value: null, label: 'Select one' });
    const { tstat: rawTstat = [], thermostat: rawThermostat = [] } = this.program.devices;
    const tstat = rawTstat.length ? rawTstat : rawThermostat;
    if (!this.question.excludeEcobee && tstat.indexOf('ecobee') > -1) {
      this.options.push({ value: 'ecobee', label: 'step1TstatOptions.ecobee' });
    }

    if (!this.question.excludeNest && tstat.indexOf('nest') > -1) {
      this.options.push({ value: 'nest', label: 'step1TstatOptions.nest' });
      this.showNest = true;
    }

    if (!this.question.excludeSensibo && tstat.indexOf('sensibo') > -1) {
      this.options.push({ value: 'sensibo', label: 'step1TstatOptions.sensibo' });
    }

    if (!this.question.excludeHoneywell && tstat.indexOf('honeywell') > -1) {
      this.options.push(
        { value: 'resideoHoneywell', label: 'step1TstatOptions.resideoHoneywell' },
        { value: 'firstAlertHoneywell', label: 'step1TstatOptions.firstAlertHoneywell' },
        { value: 'honeywell', label: 'step1TstatOptions.honeywell' },
      );
    }

    if (!this.question.excludeHoneywellAcc && tstat.indexOf('honeywellAcc') > -1) {
      this.options.push({ value: 'honeywellAcc', label: 'step1TstatOptions.amazon' });
    }

    if (!this.question.excludeSensi && tstat.indexOf('sensi') > -1) {
      this.options.push({ value: 'sensi', label: 'step1TstatOptions.sensi' });
    }

    if (!this.question.excludeMysa && tstat.indexOf('mysa') > -1) {
      this.options.push({ value: 'mysa', label: 'step1TstatOptions.mysa' });
    }

    this.options.push({ value: 'other', label: 'step1TstatOptions.other' });
    if (Object.keys(this.program.devices).filter(key => !['thermostat', 'tstat'].includes(key)).length > 0) {
      this.options.push({ value: 'no', label: 'step1TstatOptions.no' });
    }
  },
  methods: {
    handleInput(value) {
      this.selected = value;
      this.$emit('input', value);
    },
    showModal() {
      if (this.appLoginOption) this.$root.$emit('modal.show', this.selected);
    },
  },
  components: { QuestionSelect },
};
</script>

<style scoped>
.tstat-warning {
  float: left;
  margin-top: -18px;
  margin-bottom: 8px;
}
</style>
